var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    fill: "currentColor",
    width: "432.785px",
    height: "432.785px",
    viewBox: "-10 -10 452.785 452.785",
    style: {
      enableBackground: "new 0 0 432.785 432.785"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 14,
    strokeLinejoin: "round",
    d: "M147.103,432.785h138.581c6.902,0,12.5-5.596,12.5-12.5V298.182h122.102c6.904,0,12.5-5.597,12.5-12.5V147.104 c0-6.903-5.596-12.5-12.5-12.5H298.184V12.5c0-6.903-5.598-12.5-12.5-12.5H147.103c-6.904,0-12.5,5.597-12.5,12.5v122.104H12.5 c-6.904,0-12.5,5.597-12.5,12.5v138.578c0,6.903,5.596,12.5,12.5,12.5h122.103v122.104 C134.603,427.189,140.2,432.785,147.103,432.785z M25,273.182V159.604h122.103c6.903,0,12.5-5.597,12.5-12.5V25h113.581v122.104 c0,6.903,5.596,12.5,12.5,12.5h122.102v113.578H285.684c-6.904,0-12.5,5.598-12.5,12.5v122.104H159.603V285.682 c0-6.902-5.597-12.5-12.5-12.5H25z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.30c7bad272f5b9a4c65d7451c219ae17.svg";
export { ForwardRef as ReactComponent };